import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedProperty } from '../store/slices/propertiesSlice';
import { selectAllProperties } from '../store/selectors/propertySelectors';
import { propertiesAPI } from '../services/api';
import PropertyDetails from '../components/PropertyDetails/PropertyDetails';
import { PageLoader } from '../components/loading';
import { usePropertyShareMeta } from '../utils/usePropertyShareMeta';

const matchPropertyId = (property, routeId) => String(property.id) === String(routeId);

const PropertyDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const properties = useSelector(selectAllProperties);
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  usePropertyShareMeta(property);

  useEffect(() => {
    let cancelled = false;

    const fromStore = properties.find((p) => matchPropertyId(p, id));
    if (fromStore) {
      setProperty(fromStore);
      dispatch(setSelectedProperty(fromStore));
      setLoading(false);
    } else {
      setProperty(null);
      setLoading(true);
    }

    const fetchProperty = async () => {
      try {
        const fetchedProperty = await propertiesAPI.getById(id);
        if (cancelled) return;
        setProperty(fetchedProperty);
        dispatch(setSelectedProperty(fetchedProperty));
      } catch (err) {
        if (cancelled) return;
        console.error('Error fetching property:', err);
        if (!fromStore) {
          navigate('/');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchProperty();

    return () => {
      cancelled = true;
    };
  }, [id, properties, dispatch, navigate]);

  if (loading && !property) {
    return <PageLoader type="details" />;
  }

  if (!property) {
    return <PageLoader type="details" />;
  }

  return <PropertyDetails property={property} />;
};

export default PropertyDetailsPage;
